import React from 'react';
import { useBreakpointHelpers } from '@sg/garnish';

import { useIsLoggedIn } from '@order/AuthMachine';

import type { AccountMenuScreenProps } from '../../navigation/AppNavigation.props';
import { AccountScreenContent } from './AccountScreen.content';

export const AccountScreen = ({
  navigation,
}: AccountMenuScreenProps): React.ReactElement => {
  const { isMobile } = useBreakpointHelpers();

  const isLoggedIn = useIsLoggedIn();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: !isMobile,
    });
  }, [navigation, isMobile]);

  return <AccountScreenContent testID="account-menu" isLoggedIn={isLoggedIn} />;
};
